import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { createSelector } from 'reselect';
import { getProductId } from 'features/product-info';
import { getWishlist } from 'features/wishlist';
import { WISHLIST_ITEM_FLOW } from 'features/wishlist/ducks/actions';
import { WishlistCheckbox } from '@navi-toolbox/ui-components';
import { useBreakpoints } from 'common/hooks';

export type Props = {
  productDataIsLoading: boolean;
};

export const WishlistButton: React.FC<Props> = ({ productDataIsLoading }) => {
  const dispatch = useDispatch();

  const { t } = useTranslation();

  const breakpoints = useBreakpoints();

  const productId = useSelector(getProductId);

  const isDesktop = breakpoints?.largeDesktop || breakpoints?.desktop;

  const isInWishlistSelector = (pid?: string) =>
    createSelector(getWishlist, (wishlist) => wishlist?.some(({ code }) => code === pid)) || false;

  const isInWishlist = useSelector(isInWishlistSelector(productId));

  const onWishlistChange = (pid: string, flowQty: number) => {
    dispatch(WISHLIST_ITEM_FLOW({ productId: pid, flowQty }));
  };

  const text = {
    snackAdd: t('ui.buttons.shopping-list-snack-add'),
    tooltipAdd: t('ui.buttons.shopping-list-tooltip-add'),
    tooltipRemove: t('ui.buttons.shopping-list-tooltip-remove'),
    wishlistAdd: t('ui.buttons.shopping-list-add'),
    wishlistAdded: t('ui.buttons.shopping-list-added'),
  };

  return (
    <WishlistCheckbox
      hasText={true}
      isDesktop={isDesktop}
      size="l"
      productId={productId || ''}
      isInteractive={!productDataIsLoading}
      isChecked={isInWishlist}
      onChange={onWishlistChange}
      text={text}
    />
  );
};
